// import { Injectable } from '@angular/core';
// import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
// import { Observable } from 'rxjs';
// import { finalize } from 'rxjs/operators';
// import { InterceptorService } from './interceptor.service';
// import { SmarttableService } from './admin/smarttable.service';


// declare var Pace: any;

// @Injectable()
// export class ApiInterceptor implements HttpInterceptor {
//   constructor(
//     private readonly interceptorService: InterceptorService,     // Global loading management
//     private readonly smarttableService: SmarttableService        // Specific table loading management
//   ) {}

//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     console.log(req,"Requestttt");
    
//     // Check if the URL contains 'page' and 'limit' query parameters
//     const hasPaginationParams = req.urlWithParams.includes('page') && req.urlWithParams.includes('limit');
//     this.interceptorService.show();
//     if (hasPaginationParams) {
//       this.smarttableService.show();
//     }
//     Pace.restart();
//     return next.handle(req).pipe(
//       finalize(() => {
//         // Hide both loading indicators
//         this.interceptorService.hide();
//         if (hasPaginationParams) {
//           this.smarttableService.hide();
//         }
//         Pace.stop();
//       })
//     );
//   }
// }



import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { InterceptorService } from './interceptor.service';
import { SmarttableService } from './admin/smarttable.service';

declare var Pace: any;

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  // Tracks how many HTTP requests are currently in flight across the whole app.
  // Prevents Pace.restart()/Pace.stop() from being called once per request,
  // which was causing overlapping calls to leave body scroll locked (overflow: hidden)
  // when multiple requests (e.g. category/subcategory/brand) fire in parallel.
  private static activeRequests = 0;

  constructor(
    private readonly interceptorService: InterceptorService,     // Global loading management
    private readonly smarttableService: SmarttableService        // Specific table loading management
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log(req,"Requestttt");
    
    // Check if the URL contains 'page' and 'limit' query parameters
    const hasPaginationParams = req.urlWithParams.includes('page') && req.urlWithParams.includes('limit');
    this.interceptorService.show();
    if (hasPaginationParams) {
      this.smarttableService.show();
    }

    // Only call Pace.restart() when this is the FIRST request of a batch
    // (i.e. going from 0 active requests to 1). Previously this was called
    // on every single request, which reset Pace's internal state mid-flight
    // when requests overlapped, sometimes leaving it stuck in 'pace-running'.
    if (ApiInterceptor.activeRequests === 0) {
      Pace.restart();
    }
    ApiInterceptor.activeRequests++;

    return next.handle(req).pipe(
      finalize(() => {
        // Hide both loading indicators
        this.interceptorService.hide();
        if (hasPaginationParams) {
          this.smarttableService.hide();
        }

        ApiInterceptor.activeRequests--;

        // Only call Pace.stop() when the LAST outstanding request finishes
        // (count reaches 0). Previously this was called on every request,
        // which could stop Pace while sibling requests were still in flight,
        // leaving its state out of sync and the scroll-lock never released.
        if (ApiInterceptor.activeRequests <= 0) {
          ApiInterceptor.activeRequests = 0; // safety clamp against negative counts
          Pace.stop();
        }
      })
    );
  }
}